import { ROUTES } from 'config/constants';
import { getPersonnelAccountMode } from './getPersonnelAccountMode';

type AuthInfoForRedirect = {
  readonly id?: string;
  readonly groups?: ReadonlyArray<string>;
  readonly personnelTypes?: ReadonlyArray<string>;
  readonly currentOrganizationId?: string | null;
};

const getPersonnelAcademicQualificationPath = (personnelId?: string): string =>
  personnelId
    ? `${ROUTES.USER_PROFILE}${ROUTES.ALL_PERSONNEL}/${personnelId}/academic-qualification`
    : ROUTES.ACTIVITY;

export const getPersonnelHomePath = (authInfo: AuthInfoForRedirect): string => {
  const { mode } = getPersonnelAccountMode(authInfo);

  if (mode === 'personal') {
    return getPersonnelAcademicQualificationPath(authInfo.id);
  }

  return ROUTES.HOME_PAGE;
};

export const getPersonnelAccountSwitchPath = (
  owner: string,
  authInfo: AuthInfoForRedirect,
): string => {
  const { id: personnelId } = authInfo;

  if (owner === 'user') {
    return getPersonnelAcademicQualificationPath(personnelId);
  }

  const { mode } = getPersonnelAccountMode(authInfo);

  if (mode === 'sponsorOrg' || mode === 'researchSiteOrg') {
    return ROUTES.HOME_PAGE;
  }

  return getPersonnelAcademicQualificationPath(personnelId);
};
